import React, { useState } from "react";
import { Prompt } from "react-router-dom";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { connect } from 'react-redux'
import Images from "../../../shared/images";
import Errors from "./../../../shared/errors";
import {
    renderCurrencyField,
    renderSelectField,
    renderSingleReactSelect,
    renderTextAreaField,
    renderTextField,
    renderUrlField
} from "./../../../shared/form-helpers";
import required, { maxDecimalValue } from "../../../shared/validation";
import FormErrors from "../../../shared/form-errors";

let AnimalForm = (props) => {
    const {
        handleSubmit,
        handleDelete,
        onChangeAnimalToProp,
        pristine,
        reset,
        submitting,
        errors,
        acquisitionMethodEnum,
        mode,
        acquisitionMethodValue,
        submitFailed,
        invalid,
        allSceneSettings,
        filmId,
        onCloseForm
    } = props;

    const thisAnimal = props.initialValues || {};
    const readOnly = thisAnimal.readOnly;

    const [editUrl, setEditUrl] = useState(false);

    const acquisitionMethodOptions = (acquisitionMethodEnum || []).map((item) => { return { value: item.value, label: item.name } });

    const sceneSettingOptions = (allSceneSettings || []).map((item) => { return { value: item.id, label: item.name } });

    return (
        <>
            <Prompt when={!pristine} message="" />
            {mode === "add" && <h2 className="menu-label">Add Animal</h2>}
            {mode === "edit" && <h2 className="menu-label">Edit Animal</h2>}
            <div className="columns">
                <div className="column">
                    {errors && <Errors errors={errors} />}
                    <form autoComplete="off" onSubmit={handleSubmit}>
                        <Field
                            name="name"
                            label="Name"
                            component={renderTextField}
                            validate={[required]}
                            required
                            readOnly={readOnly}
                        />

                        <Field
                            name="sceneSettingId"
                            label="Scene Setting"
                            component={renderSingleReactSelect}
                            options={sceneSettingOptions}
                            validate={[required]}
                            required
                            readOnly={readOnly}>
                        </Field>

                        <Field
                            name="link"
                            label="Link"
                            type="url"
                            component={renderUrlField}
                            readOnly={readOnly}
                            setEditUrl={setEditUrl}
                            editUrl={editUrl}
                        />

                        <Field
                            name="description"
                            label="Description"
                            component={renderTextAreaField}
                            readOnly={readOnly}></Field>

                        <Field
                            name="acquisitionMethod"
                            label="Acquisition Method"
                            component={renderSingleReactSelect}
                            options={acquisitionMethodOptions}
                            validate={[required]}
                            required
                            readOnly={readOnly}>
                        </Field>

                        {acquisitionMethodValue != 3 && acquisitionMethodValue != 4 && acquisitionMethodValue != 5 &&
                            <Field
                                name="cost"
                                label="Cost"
                                component={renderCurrencyField}
                                validate={[maxDecimalValue(999999)]}
                                readOnly={readOnly}
                            />
                        }

                        <Field
                            name="quantity"
                            label="Quantity"
                            component={renderTextField}
                            validate={[required]}
                            required
                            readOnly={readOnly}
                        />

                        <Field
                            name="nameInScript"
                            label="Name in Script"
                            component={renderTextField}
                            readOnly={readOnly}
                        />

                        <Images
                            {...props}
                            readOnly={readOnly}
                        />

                        <FormErrors {...props} />
                        <div className="field is-grouped">
                            <div className="control">
                                <button
                                    type="submit"
                                    className="button is-primary"
                                    disabled={submitting || invalid || pristine}
                                >
                                    {mode === "add" ? "Add Animal" : "Save Animal"}
                                </button>
                            </div>
                            {mode === "edit" &&
                                <div className="control">
                                    <button
                                        type="button"
                                        className="button is-danger"
                                        disabled={submitting}
                                        onClick={() => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(thisAnimal) }}
                                    >
                                        Delete
                                    </button>
                                </div>
                            }
                            {mode === "edit" &&
                                <div className="control">
                                    <button
                                        type="button"
                                        className="button is-info"
                                        disabled={submitting}
                                        onClick={() => { if (window.confirm('Are you sure you wish to change this to a prop?')) onChangeAnimalToProp(thisAnimal) }}
                                    >
                                        Change to Prop
                                    </button>
                                </div>
                            }
                            <div className="control">
                                <button
                                    type="button"
                                    className="button"
                                    disabled={submitting}
                                    onClick={onCloseForm}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

AnimalForm = reduxForm({
    form: "animal",
    enableReinitialize: true
})(AnimalForm);

const selector = formValueSelector('animal');

const mapStateToProps = (state) => {
    const acquisitionMethodValue = selector(state, 'acquisitionMethod');
    return {
        acquisitionMethodValue,
        initialValues: state.animalsState.animal,
        reduxFormValues: state?.form?.animal?.values
    }
}

export default connect(mapStateToProps)(AnimalForm);
